import { render, staticRenderFns } from "./officialAccountStatement.vue?vue&type=template&id=5a35eb59&scoped=true"
import script from "./officialAccountStatement.vue?vue&type=script&lang=js"
export * from "./officialAccountStatement.vue?vue&type=script&lang=js"
import style0 from "./officialAccountStatement.vue?vue&type=style&index=0&id=5a35eb59&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a35eb59",
  null
  
)

export default component.exports